/**
 * 
 * Body.js
 * 
 */

 import React, { Component } from 'react';
 import ReactPlayer from 'react-player';

 // component
 import CenterWrapper from '../../../common/CenterWrapper';
import { Row, Col } from 'react-bootstrap';

 
 export default class Body extends Component {
    
    static displayName = Body.name;

    render() {

         return (

            <CenterWrapper id="demo" style={{ backgroundImage: "url('/assets/image/background/5.png')" }}>

                <Row>

                    <Col>
                        <p style={{ fontSize: '40px' }}>
                            Smile App MVP
                        </p>
                    </Col>

                </Row>

                <Row>

                    <Col>
                        <p style={{ fontSize: '20px' }}>
                        The MVP (minimum viable product) below highlights the core part of the application and main functionality. <b>Alpha version will be shared November 2020.</b>
                        </p>
                    </Col>

                </Row>


                <Row>

                    <Col lg>
                        <ReactPlayer controls="true" width="100"  url="https://www.youtube.com/watch?v=TJ7CcE8Hmx8" /> 
                    </Col>

                </Row>

                

            </CenterWrapper> 

         );



     }


 }
 

 
